export const featureNames = {
    individualWCSettings: 'individualWCSettings',
    washClubTime: 'washClubTime',
    taxableWashClub: 'taxableWashClub',
    marketing: 'marketing',
    UserFraud: 'UserFraud',
    AccountBalance: 'AccountBalance',
    reads: 'reads',
}

const AllowedFeatures = ({ feature, children }) => {

    const local = [window.location.hostname === 'localhost' ? 'dev' : ''];
    const dev = ['dev'];
    const demo = ['dev', 'demo'];
    const prod = ['dev', 'demo', 'prod'];

    const featureMap = {
        individualWCSettings: dev,
        washClubTime: dev,
        taxableWashClub: dev,
        marketing: dev,
        UserFraud: dev,
        AccountBalance: dev,
        reads: dev
    }

    return featureMap[feature].includes(process.env.REACT_APP_ENV)
        ? children
        : null;
};

export default AllowedFeatures;
